import {useCallback, useMemo} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import debounce from 'lodash/debounce';
import type {Column, PostInfoArgs} from '../types';
import {useLazyPostInfoQuery} from '../advancedSearchApi';
import {filterColumnsByType} from '../functions';

export const useAdvancedSearchInfo = (allColumns: Column[]) => {
  const [postInfo, {status, data}] = useLazyPostInfoQuery();

  const searcher = useCallback(
    ({type, columns, page, size, sort, filters}: PostInfoArgs) => {
      // If viewmode is WORK we must only send work columns.
      const filteredColumns = filterColumnsByType(allColumns, type, columns);

      return postInfo({
        type,
        filters,
        columns: filteredColumns,
        page,
        size,
        sort,
      });
    },
    [allColumns, postInfo],
  );

  const debouncedPostInfo = useMemo(() => debounce(searcher, 200), [searcher]);

  return {
    postInfo: debouncedPostInfo,
    isLoading: status === QueryStatus.pending,
    data: data ?? {rows: [], hits: 0},
  };
};
